import React, { useState } from "react";
import { Table, Tag, Button, Modal, Descriptions, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const BWTSDetailsTable = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedBWTS, setSelectedBWTS] = useState(null);

  const showModal = (record) => {
    setSelectedBWTS(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedBWTS(null);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "BWT_name",
      key: "BWT_name",
    },
    {
      title: "Make",
      dataIndex: "BWT_maker",
      key: "BWT_maker",
    },
    {
      title: "Model",
      dataIndex: "BWT_model",
      key: "BWT_model",
    },

    {
      title: "Selected Parameters",
      dataIndex: "selected_parameters",
      key: "selected_parameters",
      width: "50%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((param, index) => (
              <Tag color="blue" key={index}>
                {param}
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },

    {
      title: "Other Parameters",
      dataIndex: "other_parameters",
      key: "other_parameters",
      width: "20%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((item, index) => (
              <Tag color="green" key={index}>
                {item.name} ({item.unit})
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              size="small"
            >
              View
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-table"
      />

      <Modal
        title="BWTS Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {selectedBWTS && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Title">{selectedBWTS.BWT_name}</Descriptions.Item>
            <Descriptions.Item label="Make">{selectedBWTS.BWT_maker}</Descriptions.Item>
            <Descriptions.Item label="Model">{selectedBWTS.BWT_model}</Descriptions.Item>
            <Descriptions.Item label="Selected Parameters">
              {Array.isArray(selectedBWTS.selected_parameters) &&
              selectedBWTS.selected_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedBWTS.selected_parameters.map((param, index) => (
                    <Tag color="blue" key={index}>
                      {param}
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Other Parameters">
              {Array.isArray(selectedBWTS.other_parameters) &&
              selectedBWTS.other_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedBWTS.other_parameters.map((item, index) => (
                    <Tag color="green" key={index}>
                      {item.name} ({item.unit})
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default BWTSDetailsTable;
